import { State } from 'src/redux/reducer';

export const journalSelector = (state: State) => state.journal;
